(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setWishlistState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    var label = active
      ? button.getAttribute('data-label-remove')
      : button.getAttribute('data-label-add');
    if (label) button.setAttribute('aria-label', label);
  }

  function bindWishlist(root) {
    var buttons = root.querySelectorAll('[data-av-wishlist]');
    if (!buttons.length) return;

    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem('av-wishlist') || '[]');
    } catch (error) {
      stored = [];
    }

    function normalize(list) {
      return list.map(function (item) {
        if (item && typeof item === 'object') {
          return { id: String(item.id || ''), handle: item.handle || '' };
        }
        return { id: String(item), handle: '' };
      });
    }

    function hasId(list, id) {
      return list.some(function (item) {
        return item.id === id;
      });
    }

    stored = normalize(stored);

    buttons.forEach(function (button) {
      var id = String(button.getAttribute('data-product-id') || '');
      var handle = button.getAttribute('data-product-handle') || '';
      if (!id) return;
      setWishlistState(button, hasId(stored, id));

      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var next = [];
        try {
          next = normalize(JSON.parse(localStorage.getItem('av-wishlist') || '[]'));
        } catch (err) {
          next = [];
        }

        var exists = hasId(next, id);
        next = exists
          ? next.filter(function (item) {
              return item.id !== id;
            })
          : next.concat({ id: id, handle: handle });
        localStorage.setItem('av-wishlist', JSON.stringify(next));
        setWishlistState(button, !exists);
      });
    });
  }

  function revealItems(items, options) {
    if (!items.length) return;

    if (prefersReducedMotion || !window.gsap) {
      items.forEach(function (item) {
        item.style.opacity = '1';
        item.style.transform = 'none';
      });
      return;
    }

    window.gsap.fromTo(
      items,
      { opacity: 0, y: 28, scale: 0.98 },
      Object.assign(
        {
          opacity: 1,
          y: 0,
          scale: 1,
          duration: 0.6,
          ease: 'power2.out',
          stagger: 0.05,
          overwrite: true,
        },
        options || {}
      )
    );
  }

  function setupScrollReveal(container) {
    var items = Array.from(container.querySelectorAll('[data-grid-item]'));
    if (!items.length) return;

    if (prefersReducedMotion || !window.gsap || !window.ScrollTrigger) {
      items.forEach(function (item) {
        item.style.opacity = '1';
      });
      return;
    }

    window.gsap.set(items, { opacity: 0, y: 28 });
    window.ScrollTrigger.batch(items, {
      start: 'top 92%',
      once: true,
      onEnter: function (batch) {
        revealItems(batch);
      },
    });
  }

  function handleFilterUpdate(container) {
    bindWishlist(container);
    var items = Array.from(container.querySelectorAll('[data-grid-item]'));
    if (!items.length) return;

    if (prefersReducedMotion || !window.gsap) {
      items.forEach(function (item) {
        item.style.opacity = '1';
        item.style.transform = 'none';
      });
      return;
    }

    window.gsap.set(items, { opacity: 0, y: 20, scale: 0.98 });
    revealItems(items, { duration: 0.5, stagger: 0.04 });
  }

  function watchContainer(container) {
    if (!container || container.dataset.premiumGridBound === 'true') return;
    container.dataset.premiumGridBound = 'true';

    bindWishlist(container);
    setupScrollReveal(container);

    var observer = new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return mutation.type === 'childList' && mutation.addedNodes.length > 0;
      });
      if (relevant) handleFilterUpdate(container);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function init() {
    watchContainer(document.getElementById('ProductGridContainer'));
    document.querySelectorAll('.related-products').forEach(watchContainer);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
